import abi from './Transactions.json';

export const contractAddress = '0x5eAB8B266e62528a38D0B3c433F79DB7a3ba26BF';
export const contractABI = abi.abi;
